/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrtool1Inputs */

const en_qrtool1 = /** @type {(inputs: Qrtool1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR Code Generator`)
};

const de_qrtool1 = /** @type {(inputs: Qrtool1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR-Code-Generator`)
};

/**
* | output |
* | --- |
* | "QR Code Generator" |
*
* @param {Qrtool1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrtool1 = /** @type {((inputs?: Qrtool1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrtool1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrtool1(inputs)
	return de_qrtool1(inputs)
});
export { qrtool1 as "qrTool" }